import axios from 'axios';
import Cookies from 'universal-cookie';
import TokenService from "./tokenService";

import {
  refreshToken,
} from '../actions';


const cookies = new Cookies();

export default {
  setupInterceptors: (store) => {
    const key = '_vto';
    const keyOA = '_vtoa';

    axios.interceptors.request.use((config) => {

      if (!config || !config.url) {
        return config;
      }

      let path = config.url.split('//')[1]
      if (!path) {
        return config;
      }

      path = path.split('/');

      if (path.length && path[2] === 'public') {
        return config;
      }

      let token = cookies.get(key);

      let localAccessToken = TokenService.getLocalAccessToken();
      let localRefreshToken = TokenService.getLocalRefreshToken();

      if (token && (!localAccessToken)) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (localAccessToken) {
        config.headers.Authorization = `Bearer ${localAccessToken}`;
      }
      if (localRefreshToken && config.url.includes('/logout')){
        config.headers.refresh_token = localRefreshToken;
      }
      return config;
    }, (err) => {
      return Promise.reject(err);
    })

    axios.interceptors.response.use((response) => {
      return response;
    }, async (err) => {
      const originalConfig = err.config;
      const path = window.location.pathname;

      let oauthTokens;
      let localAccessToken = TokenService.getLocalAccessToken();
      let localRefreshToken = TokenService.getLocalRefreshToken();

      if (localAccessToken && localRefreshToken) {
        oauthTokens = {
          localAccessToken,
          localRefreshToken
        };
      }

      if (
        path === '/login'
        || path === '/register'
        || path === '/forgot-password'
        || path === '/password/reset'
        || path === '/verify-email'
        || path === '/verify-ip'
        || path === '/recover'
        || path === '/reset-two-factor'
        || path === '/verify-two-factor'
        || path === '/reverify'
        || path === '/oauth/redirect'
        || path === '/change-email'
        || path === '/validate'
      ) {
        return Promise.reject(err);
      }

      if (originalConfig.url !== "/login") {
        if (err.response.status === 401 && !originalConfig._retry && oauthTokens) {
          originalConfig._retry = true;
          try {
            // get new accessToken
            const postUrl = process.env.REACT_APP_OAUTH_POST_URL || `http://identity.local:3192/oauth/token`;
            const postBody = {
              client_id: process.env.REACT_APP_OAUTH_CLIENT_ID,
              grant_type: 'refresh_token',
              refresh_token: oauthTokens.localRefreshToken
            };
            var formBody = [];
            for (var property in postBody) {
              var encodedKey = encodeURIComponent(property);
              var encodedValue = encodeURIComponent(postBody[property]);
              formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            const requestMetadata = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Accept': 'application/json'
              },
              body: formBody
            };

            const { dispatch } = store;

            const response = await fetch(postUrl, requestMetadata);

            let accessToken = '';
            if (response.ok) {
              const json = await response.json();
              if (json && json.access_token) {
                accessToken = json.access_token;
              }
            }

            const cookieKey = '_vtoa';
            const secure = false;

            const cookieData = {
              access_token: accessToken,
              refresh_token: oauthTokens.localRefreshToken,
            };

            cookies.set(cookieKey, JSON.stringify(cookieData), { hostname: process.env.REACT_APP_HOSTNAME, path: '/', secure });

            dispatch(refreshToken(accessToken));
            TokenService.updateLocalAccessToken(accessToken);

            originalConfig._retry = false;
            return axios(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        } else if (err.response.status === 401) {
          return window.location.href = '/login?logged=true';
        }
        return Promise.reject(err);

      }
    });
  },
};
